module.exports = __webpack_public_path__ + "img/more-icon.a7eeade7.svg";